import { render, staticRenderFns } from "./CampaignDraftsTab.vue?vue&type=template&id=5e479698&"
import script from "./CampaignDraftsTab.vue?vue&type=script&lang=js&"
export * from "./CampaignDraftsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports